import { EasyBrief } from './components/EasyBrief';
import { TipsAndGuides } from './components/TipsAndGuides';

export const HowToSection: React.FC = () => {
	return (
		<div className="bg-background-base" data-testid="homepage-how-to-section">
			<EasyBrief />
			<TipsAndGuides />
		</div>
	);
};
